import React, { useEffect, useState } from "react";

import {
  Button,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";

import { useSnackbar } from "notistack";

import useStyle from "../../../useStyles";

import {
  verificarFormularioVinculado as verificarFormularioVinculadoService,
} from "../../../../../services/reuniao/ReuniaoService";
import {
  sumula,
} from "../../../../../services/preenchimentoFormulario/PreenchimentoFormularioService";

import AccordionRespostas from "../../../accordionRespostas";
import FormularioSumulaButtons from "../../../formularioSumula/formularioSumulaButtons";
import FormularioStatus from "../../../formularioSumula/formularioStatus/";

const ReuniaoFormulario = (props) => {
  const { isVisualizar, dados, updateDados, history } = props;

  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyle();

  const [exportarSumulaAnchorElement, setExportarSumulaAnchorElement] =
    useState(null);

  const [acoesAnchorElement, setAcoesAnchorElement] = useState(null);
  const [openDataInicioFim, setOpenDataInicioFim] = useState(false);
  const [openDataInicioFimOnSubmit, setOpenDataInicioFimOnSubmit] =
    useState("");

  const [openConfirmacao, setOpenConfirmacao] = useState(false);
  const [openConfirmacaoMensagens, setOpenConfirmacaoMensagens] = useState({});
  const [
    openConfirmacaoMensagensOnSubmit,
    setOpenConfirmacaoMensagensOnSubmit,
  ] = useState("");

  const verificarFormularioVinculado = (idReuniao) => {
    verificarFormularioVinculadoService(idReuniao).then((response) => {

      if (
        response &&
        response.status === 200 &&
        Object.keys(response.data).length > 0
      ) {
        const data = response.data;
        let dadosFormularios = {
          // formulario: {
          // ...dados.formulario,
          id: data.id,
          nome: data.nomeFormulario,
          // },
        };

        if (data.status) {
          dadosFormularios.status = data.status;
          dadosFormularios.dataInicio = data.dataInicio;
          dadosFormularios.dataLimite = data.dataLimite;
        } 
        else {
          dadosFormularios.status = null;
          dadosFormularios.dataInicio = null;
          dadosFormularios.dataLimite = null;
          dadosFormularios.preenchimentos = []
        }
        // setFormularioVinculado(dadosFormularios);
        // updateDados({ ...dados, ...dadosFormularios });
        updateDados((prevDados) => ({
          ...prevDados,
          formulario: {
            ...prevDados.formulario,
            ...dadosFormularios,
          },
        }));
      } else if (response && response.status === 404) {
        // "Nenhum Formulário vinculado nesta reunião"
        // Formulário não encontrado para a reunião selecionada.

        updateDados((prevDados) => ({
          ...prevDados,
          formulario: {
            id: null,
            nome: null,
            status: null,
            dataInicio: null,
            dataLimite: null,
            preenchimentos: []
          },
        }));
        // response.data.message
        enqueueSnackbar('Nenhum formulário está vinculado nesta reunião', {
          variant: "warning",
        });
        // console.log('-----404')
        // console.log(response)
      } else {
        enqueueSnackbar(
          "Ocorreu um erro ao recuperar se há Formulário vinculado",
          {
            variant: "error",
          }
        );
      }
    });
  };

  const getSumulaDados = (idReuniao) => {
    sumula(idReuniao).then((response) => {
      if (response && response.status === 200 && Object.keys(response.data).length > 0) {
        const data = response.data;
        // setRespostasFormularioPorEstado(data.preenchimentos);
        let dadosFormularioSumula;

        if (data.status == "DISPONIBILIZADO" || data.status == "ENCERRADO") {
          dadosFormularioSumula = {
            // formulario: {
            // ...dados.formulario,
            status: data.status,
            dataInicio: data.dataInicio,
            dataLimite: data.dataLimite,
            preenchimentos: data.preenchimentos,
            // },
          };
        } else {
          dadosFormularioSumula = {
            // formulario: {
              // ...dados.formulario,
              status: data.status,
              dataInicio: data.dataInicio,
              dataLimite: data.dataLimite,
              preenchimentos: null,
            // },
          };
        }

        // updateDados({ ...dados, ...dadosFormularioSumula });
        updateDados((prevDados) => ({
          ...prevDados,
          formulario: {
            ...prevDados.formulario,
            ...dadosFormularioSumula,
          },
        }));
      // } else if (response && response.status === 500) {
      //   enqueueSnackbar("Ocorreu um erro ao recuperar se há dados da Súmula", {
      //     variant: "error",
      //   });

        // console.log("Ocorreu um erro ao recuperar se foi disponibilizado");
      } else if (response
        //  && response.status === 404
        ) {
        enqueueSnackbar("Não há nenhum formulário disponibilizado", {
          variant: "error",
        });

        // console.log("Ocorreu um erro ao recuperar se foi disponibilizado");
      }
    });
  };

  const handleButtonFinalizar = () => {
    history.push(`/reuniao/${dados.id}/visualizar`);
  };

  const handleMenuAcoesClose = () => {
    setAcoesAnchorElement(null);
  };

  const handleButtonDataInicioFimCancelar = () => {
    setOpenDataInicioFim(false);
  };

  useEffect(() => {
    if (dados.id) verificarFormularioVinculado(dados.id);
  }, []);

  useEffect(() => {
    if (dados.formulario.id) {
        getSumulaDados(dados.id);
      }
  }, [
    dados.formulario?.id,
    dados.formulario?.status,
    dados.formulario?.dataInicio,
    dados.formulario?.dataLimite,
  ]);

  return (
    <>
      <Grid className={classes.gridMaster}>
        <Grid className={classes.gridSumula}>
          <Typography className={classes.tituloAba} component="div">
            Formulário
          </Typography>
          {!isVisualizar && (
            <Button onClick={handleButtonFinalizar} variant="contained">
              Finalizar
            </Button>
          )}
        </Grid>
        <Divider />

        <Grid style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid className={classes.gridFormularioInformacoes}>
            <FormularioStatus
              nome={dados.formulario.nome}
              dataInicio={dados.formulario.dataInicio}
              dataLimite={dados.formulario.dataLimite}
            />
          </Grid>
          <Grid className={classes.gridBotoesSumula}>
            <FormularioSumulaButtons
              dados={dados}
              updateDados={updateDados}
            />
          </Grid>
        </Grid>

        <Divider />
        <Grid>
          {dados?.formulario?.preenchimentos?.length > 0 && (
            <AccordionRespostas respostas={dados.formulario.preenchimentos}/>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ReuniaoFormulario;
